<template>
  <v-dialog
    v-model="dialog"
    max-width="1200px"
    persistent
  >
    <template v-slot:activator="{ on }">
      <v-btn
        text
        icon
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      title="Payroll Company"
      text="Create Payroll Company"
      class="mb-0"
    >
      <form v-if="!loading">
        <v-container>
          <v-row>
            <v-col cols="4">
              <v-row>
                <v-col
                  cols="12"
                  class="mt-5 px-0"
                >
                  <span class="font-weight-bold font-large">Company</span>
                </v-col>
                <v-col
                  cols="12"
                  class="pa-0"
                >
                  <v-autocomplete
                    v-model="company"
                    v-validate="'required'"
                    data-vv-name="company"
                    data-vv-as="company"
                    :items="companies"
                    :error-messages="errors.collect('company')"
                    item-text="name"
                    item-value="id"
                    label="Company"
                    outlined
                  />
                </v-col>

                <v-col
                  cols="12"
                  class="pa-0"
                >
                  <v-menu
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="startDateDisplay"
                        v-validate="'required'"
                        :error-messages="errors.collect('startDateDisplay')"
                        data-vv-name="startDateDisplay"
                        data-vv-as="start date"
                        label="Start date"
                        outlined
                        readonly
                        class="label-position"
                        v-on="on"
                        @input="clearConsole"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>
                            mdi-calendar
                          </v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      no-title
                      @input="startDateMenu = false"
                    />
                  </v-menu>
                </v-col>

                <v-col
                  cols="12"
                  class="pa-0"
                >
                  <v-text-field
                    v-model="basicSalary"
                    v-validate="'required'"
                    v-money="money"
                    label="Basic Salary"
                    :error-messages="errors.collect('basicSalary')"
                    data-vv-name="basicSalary"     
                    data-vv-as="basic salary"
                    prefix="RM"
                    outlined
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-divider vertical />

            <v-col>
              <v-row>
                <v-col
                  cols="2"
                  class="ma-auto"
                >
                  <span class="font-weight-bold font-large">EPF</span>
                </v-col>
                <v-col cols="10">
                  <v-row>
                    <v-row class="pa-0 ma-0">
                      <v-col
                        class="py-0"
                      >
                        <span> Is Employee EPF Contribute? </span>
                        <v-radio-group
                          v-model="isEmployeeEpfContribute"
                          class="mt-2"
                          row
                          @change="employeeContributionDeduction = null; employeeCustomizedRate = null; employeeCustomizedAmount = 0;"
                        >
                          <v-radio
                            label="No"
                            :value="0"
                          />
                          <v-radio
                            label="Yes"
                            :value="1"
                          /> 
                        </v-radio-group>
                      </v-col>

                      <v-col
                        v-if="isEmployeeEpfContribute"
                        class="py-0"
                      >
                        <v-autocomplete
                          v-model="employeeEpfContributionType"
                          v-validate="isEmployeeEpfContribute ? 'required' : ''"
                          label="Employee EPF Contribution Type"
                          :error-messages="errors.collect('employeeEpfContributionType')"
                          data-vv-name="employeeEpfContributionType"
                          data-vv-as="employee EPF contribution type"
                          clearable
                          item-value="id"
                          item-text="name"
                          :items="epfContributionCategories"
                        />
                      </v-col>
                      
                      <v-col
                        v-if="isEmployeeEpfContribute && employeeEpfContributionType === 1"
                        cols="12"
                        class="pb-0"
                      >
                        <v-autocomplete
                          v-model="employeeContributionDeduction"
                          v-validate="employeeEpfContributionType === 1 ? 'required' : ''"
                          label="Employee Epf Rate (Follow Government)"
                          :error-messages="errors.collect('employeeContributionDeduction')"
                          data-vv-name="employeeContributionDeduction"
                          data-vv-as="employee follow government epf rate"
                          clearable
                          item-value="id"
                          :item-text="item => '['+item.code+'] - '+ item.name"
                          :items="contributionDeductions"
                          outlined
                          @change="employeeCustomizedRate = null; employeeCustomizedAmount = 0; employerContributionDeduction = employeeContributionDeduction"
                        />
                      </v-col>
                      <v-col
                        v-if="isEmployeeEpfContribute && employeeEpfContributionType === 2"
                        cols="12"
                        class="pb-0"
                      >
                        <v-text-field
                          v-model="employeeCustomizedRate"
                          v-validate="employeeEpfContributionType === 2 ? 'required|oneDecimalValue|pointFive' : ''"
                          :error-messages="errors.collect('employeeCustomizedRate')"
                          data-vv-name="employeeCustomizedRate"
                          data-vv-as="employee customized EPF rate"
                          label="Employee Customized EPF Rate"
                          type="number"
                          suffix="%"
                          clearable
                          outlined
                          @change="employeeContributionDeduction = null; employeeCustomizedAmount = 0;"
                        />
                      </v-col>
                      <v-col
                        v-if="isEmployeeEpfContribute && employeeEpfContributionType === 3"
                        cols="12"
                        class="pb-0"
                      >
                        <v-text-field
                          v-model="employeeCustomizedAmount"
                          v-validate="employeeEpfContributionType === 3 ? 'required' : ''"
                          v-money="money"
                          :error-messages="errors.collect('employeeCustomizedAmount')"
                          data-vv-name="employeeCustomizedAmount"
                          data-vv-as="employee customized EPF amount"
                          label="Employee Customized EPF Amount"
                          prefix="RM"
                          outlined
                          @change="employeeContributionDeduction = null; employeeCustomizedRate = null;"
                        />
                      </v-col>
                    </v-row>
                    
                    <v-row class="pa-0 ma-0">
                      <v-col
                        class="py-0"
                      >
                        <span> Is Employer EPF Contribute? </span>
                        <v-radio-group
                          v-model="isEmployerEpfContribute"
                          class="mt-2"
                          row
                          @change="employerContributionDeduction = null; employerCustomizedRate = null; employerCustomizedAmount = 0"
                        >
                          <v-radio
                            label="No"
                            :value="0"
                          />
                          <v-radio
                            label="Yes"
                            :value="1"
                          /> 
                        </v-radio-group>
                      </v-col>

                      <v-col
                        v-if="isEmployerEpfContribute"
                        class="py-0"
                      >
                        <v-autocomplete
                          v-model="employerEpfContributionType"
                          v-validate="isEmployerEpfContribute ? 'required' : ''"
                          label="Employer EPF Contribution Type"
                          :error-messages="errors.collect('employerEpfContributionType')"
                          data-vv-name="employerEpfContributionType"
                          data-vv-as="employer EPF contribution type"
                          clearable
                          item-value="id"
                          item-text="name"
                          :items="epfContributionCategories"
                        />
                      </v-col>

                      <v-col
                        v-if="isEmployerEpfContribute && employerEpfContributionType === 1"
                        cols="12"
                        class="pb-0"
                      >
                        <v-autocomplete
                          v-model="employerContributionDeduction"
                          v-validate="employerEpfContributionType === 1 ? 'required' : ''"
                          label="Employer Epf Rate (Follow Government)"
                          :error-messages="errors.collect('employerContributionDeduction')"
                          data-vv-name="employerContributionDeduction"
                          data-vv-as="employer follow government epf rate"
                          clearable
                          item-value="id"
                          :item-text="item => '['+item.code+'] - '+ item.name"
                          :items="filteredContributionDeductions"
                          outlined
                          @change="employerCustomizedRate = null; employerCustomizedAmount = 0;"
                        />
                      </v-col>
                      <v-col
                        v-if="isEmployerEpfContribute && employerEpfContributionType === 2"
                        cols="12"
                        class="pb-0"
                      >
                        <v-text-field
                          v-model="employerCustomizedRate"
                          v-validate="employerEpfContributionType === 2 ? 'required|oneDecimalValue|pointFive' : ''"
                          :error-messages="errors.collect('employerCustomizedRate')"
                          data-vv-name="employerCustomizedRate"
                          data-vv-as="employer customized EPF rate"
                          label="Employer Customized EPF Rate"
                          type="number"
                          suffix="%"
                          clearable
                          outlined
                          @change="employerContributionDeduction = null; employerCustomizedAmount = 0;"
                        />
                      </v-col>
                      <v-col
                        v-if="isEmployerEpfContribute && employerEpfContributionType === 3"
                        cols="12"
                        class="pb-0"
                      >
                        <v-text-field
                          v-model="employerCustomizedAmount"
                          v-validate="employerEpfContributionType === 3 ? 'required' : ''"
                          v-money="money"
                          :error-messages="errors.collect('employerCustomizedAmount')"
                          data-vv-name="employerCustomizedAmount"
                          data-vv-as="employer customized EPF amount"
                          label="Employer Customized EPF Amount"
                          prefix="RM"
                          outlined
                          @change="employerContributionDeduction = null; employerCustomizedRate = null;"
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </v-col>
              </v-row>

              <v-divider style="margin-left:0px !important; margin-right:0px !important" />
              <v-row>
                <v-col
                  cols="2"
                  class="ma-auto"
                >
                  <span class="font-weight-bold font-large">SOCSO</span>
                </v-col>
                <v-col cols="10">
                  <v-row>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span> Is Employee SOCSO Contribute? </span>
                      <v-radio-group
                        v-model="isEmployeeSocsoContribute"
                        row
                      >
                        <v-radio
                          label="No"
                          :value="0"
                        />
                        <v-radio
                          label="Yes"
                          :value="1"
                        /> 
                      </v-radio-group>
                    </v-col>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span> Is Employer SOCSO Contribute? </span>
                      <v-radio-group
                        v-model="isEmployerSocsoContribute"
                        row
                      >
                        <v-radio
                          label="No"
                          :value="0"
                        />
                        <v-radio
                          label="Yes"
                          :value="1"
                        /> 
                      </v-radio-group>
                    </v-col>

                    <v-col
                      cols="12"
                      class="py-0"
                    >
                      <v-autocomplete
                        v-model="socsoContributionCategory"
                        v-validate="isEmployeeSocsoContribute ? 'required' : ''"
                        :error-messages="errors.collect('socsoContributionCategory')"
                        :items="socsoContributionCategories"
                        data-vv-name="socsoContributionCategory"
                        data-vv-as="SOCSO contribution category"
                        item-text="name"
                        item-value="key"
                        label="SOCSO Contribution Category"
                        outlined
                      >
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <span class="font-weight-bold">{{ data.item.name }}</span>
                            <span style="width:100px">{{ data.item.description }}</span>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-divider style="margin-left:0px !important; margin-right:0px !important" />

              <v-row>
                <v-col
                  cols="2"
                  class="ma-auto"
                >
                  <span class="font-weight-bold font-large">EIS</span>
                </v-col>
                <v-col
                  cols="5"
                  class="mt-4"
                >
                  <span> Is Employee EIS Contribute? </span>
                  <v-radio-group
                    v-model="isEmployeeEisContribute"
                    row
                  >
                    <v-radio
                      label="No"
                      :value="0"
                    />
                    <v-radio
                      label="Yes"
                      :value="1"
                    /> 
                  </v-radio-group>
                </v-col>
                <v-col
                  cols="5"
                  class="mt-4"
                >
                  <span> Is Employer EIS Contribute? </span>
                  <v-radio-group
                    v-model="isEmployerEisContribute"
                    row
                  >
                    <v-radio
                      label="No"
                      :value="0"
                    />
                    <v-radio
                      label="Yes"
                      :value="1"
                    /> 
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"        
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  import { VMoney } from 'v-money'
  export default { 
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      employeeUid: {
        type: String,
        default: null,
      }, 
      companyEmployees: {
        type: Array,
        default: null,
      },   
    },
    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,
        companies: [],
        company: null,
        startDateMenu: false,
        startDate: null,
        employeeEpfContributionType: 1,
        employerEpfContributionType: 1,
        epfContributionCategories: [
          { id: 1, name: 'Follow Government' },
          { id: 2, name: 'By Custom Rate (%)' },
          { id: 3, name: 'By Custom Amount (RM)' },
        ],
        isEmployeeSocsoContribute: 1,
        isEmployerSocsoContribute: 1,
        socsoContributionCategories: [
          { key: 1, name: 'First Category', description: 'All employees who have not reached the age of 60, must contribute under the First Category except for those who have attained 55 years of age and have no prior contributions before they reach 55 due to non-eligibility under the Employees’ Social Security Act, 1969' },
          { key: 2, name: 'Second Category', description: 'All employees who have reached the age of 60 must be covered under this category for the Employment Injury Scheme only.' },
        ],
        socsoContributionCategory: 1, // default value: First Category
        isEmployeeEisContribute: 1,
        isEmployerEisContribute: 1,
        contributionDeductions: [],
        employeeContributionDeduction: null,
        employeeCustomizedRate: null,
        employeeCustomizedAmount: null,
        employerContributionDeduction: null,
        employerCustomizedRate: null,
        employerCustomizedAmount: null,
        basicSalary: null,
        isEmployeeEpfContribute: 1,
        isEmployerEpfContribute: 1,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    computed: {
      filteredContributionDeductions () {
        if (!this.employeeContributionDeduction) return this.contributionDeductions

        return this.contributionDeductions.filter(contributionDeduction => {
          return contributionDeduction.id === this.employeeContributionDeduction
        })
      },

      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.loadData()

        let _this = this

        this.$validator.extend('oneDecimalValue', {
          getMessage (field, args) {
            return 'Only 1 Decimals are allowed'
          },
          validate (value, args) {
            return _this.isValidNumbers(value)
          },
        })

        this.$validator.extend('pointFive', {
          getMessage (field, args) {
            return 'Only 0.5 is allowed'
          },
          validate (value, args) {
            if (value.toString().indexOf('.') > -1) {
              let arr = [...value.split('.')[1]]
              return arr[0] === '5' || arr[0] === '0'
            } else {
              return true
            }
          },
        })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.hrisCompanyEmployees().create(this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })
                
                this.progressing = false
                this.dialog = false
              })
          })
      },
      loadData () {
        this.loading = true

        Promise.all([
          this.$api.hrisCompanies().list('?filter_by=organization'),
          this.$api.contributionDeductions().list('?with=epf'),
        ])      
          .then(([ companies, contributionDeduction ]) => {
            let existingCompanyUid = this.companyEmployees.filter(companyEmployee => {
              return !companyEmployee.end_date
            }).map(companyEmployee => {
              return companyEmployee.company.id
            })

            this.companies = _.orderBy(companies.data.filter(companyEmployee => {
              return !existingCompanyUid.includes(companyEmployee.id)
            }), ['name'], ['asc'])

            this.contributionDeductions = contributionDeduction.data
          
            this.loading = false
          })
      },

      prepareFormData () {
        return {
          employee_uid: this.employeeUid,
          start_date: this.startDate,
          company_uid: this.company,
          is_active_pay_status: 1,
          employee_contribution_deduction_id: this.employeeEpfContributionType === 1 ? this.employeeContributionDeduction : null,
          employee_customized_rate: this.employeeEpfContributionType === 2 ? this.employeeCustomizedRate : null,
          employee_customized_amount: this.employeeEpfContributionType === 3 ? this.employeeCustomizedAmount.toString().replaceAll(',', '') : 0,
          employer_contribution_deduction_id: this.employerEpfContributionType === 1 ? this.employerContributionDeduction : null,
          employer_customized_rate: this.employerEpfContributionType === 2 ? this.employerCustomizedRate : null,
          employer_customized_amount: this.employerEpfContributionType === 3 ? this.employerCustomizedAmount.toString().replaceAll(',', '') : 0,
          is_employee_contributed: this.isEmployeeSocsoContribute,
          is_employer_contributed: this.isEmployerSocsoContribute,
          contribution_category: this.socsoContributionCategory,
          eis_is_employee_contributed: this.isEmployeeEisContribute,
          eis_is_employer_contributed: this.isEmployerEisContribute,
          basic_salary: this.basicSalary.toString().replaceAll(',', ''),
          is_employee_epf_contributed: this.isEmployeeEpfContribute,
          is_employer_epf_contributed: this.isEmployerEpfContribute,
        }
      },

      isValidNumbers (value) {
        value = value.toString().replaceAll(',', '')
        return (new Big(value).times(10000) % 100 === 0)
      },
      clearConsole () {
        console.clear()
      },
    },
  }
</script>

<style scoped>
.font-large{
  font-size:x-large
}
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
